module.exports = __webpack_public_path__ + "img/anchor.6435577d.png";